import { useEffect, useState } from "react";
// import LeftSidePopupLayout from '..../../../../component/popup/modal-layout';
// import XCloseIcon from '../../../../component/icons/x-close';
import Style from "./style.module.css";
import LeftSidePopupLayout from "../../../../../component/popup/modal-layout";
import XCloseIcon from "../../../../../component/icons/x-close";

const CustomizeTabsOverviewPopup = ({ tabs, onClose, onToggle, data }) => {
  const [popupStatus, setPopupStatus] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setPopupStatus(true);
    }, 400);
  }, []);

  const closeFun = () => {
    setPopupStatus(false);

    setTimeout(() => {
      onClose();
    }, 400);
  };

  return (
    <LeftSidePopupLayout
      popupStatus={popupStatus}
      onClose={() => closeFun()}
      className={Style.customize_modal}
    >
      <div className={Style.modal_header}>
        <h4>Customize Tabs</h4>
        <button onClick={() => closeFun()} className={Style.close_btn}>
          <XCloseIcon />
        </button>
      </div>

      <div className={Style.modal_body}>
        {data.map((tab) => {
          return (
            <div className={Style.tab_toggle} key={tab?.key}>
              <span>{tab?.label}</span>
              <label className={Style.switch}>
                <input
                  type="checkbox"
                  checked={tabs?.[tab?.key] || false}
                  disabled={tab?.key == "details"}
                  onChange={() => onToggle(tab?.key)}
                />
                <span className={`${Style.slider} ${Style.round}`}>
                  <div className={Style.sliderCenterCircle}></div>
                </span>
              </label>
            </div>
          );
        })}
      </div>
    </LeftSidePopupLayout>
  );
};

export default CustomizeTabsOverviewPopup;
